import { FaPlane } from "react-icons/fa";
import { DateRangeFilter } from "../reportSummary/DateRangeFilter";

export function FlightDashboardHeader({ timeRange, onTimeRangeChange }) {
  return (
    <div className="flex items-center justify-between gap-4 pb-2">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#1E61DC] to-[#3B82F6] shadow-lg shadow-blue-500/20">
          <FaPlane className="w-6 h-6 text-white" />
        </div>
        <div>
          <span className="text-[#1A1A1A] mb-1 md:text-xl">
            Flights Revenue Dashboard
          </span>
          <p className="text-[#6B7280] text-sm hidden md:block">
            Comprehensive flight booking analytics and performance metrics
          </p>
        </div>
      </div>
      <DateRangeFilter value={timeRange} onChange={onTimeRangeChange} />
    </div>
  );
}
